@if(fallback(); as fb){
    @if(activated.snapshot.queryParams.debug){
        @let parts1 = fb.split('#');
        @let parts2 = parts1[0].split('?');
        <p class="mx-4">
            <span class="font-semibold">URL</span><br/>
            <span class="font-light">{{parts2[0]}}</span><br/>
            <span class="font-semibold">QUERY PARAMETERS</span><br/>
    
            @for(queryParam of parts2[1].split('&'); track queryParam){
                <span class="font-light">{{queryParam.replace('=',' = ')}}</span><br/>
            }
            <span class="font-semibold">FRAGMENT</span><br/>
            <span class="font-light">{{parts1[2]}}</span><br/>
        </p>
    }
    <a mat-flat-button [href]="fb">CONTINUE</a>
} @else {
    <div class="svg-loader">
        <object data="/old/cloudigo_loader.svg" type="image/svg+xml"></object>
    </div>
}
